import { render, staticRenderFns } from "./CoachList.vue?vue&type=template&id=19aede42&scoped=true"
import script from "./CoachList.vue?vue&type=script&lang=js"
export * from "./CoachList.vue?vue&type=script&lang=js"
import style0 from "./CoachList.vue?vue&type=style&index=0&id=19aede42&prod&lang=scss&scoped=true"
import style1 from "./CoachList.vue?vue&type=style&index=1&id=19aede42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aede42",
  null
  
)

export default component.exports